<template>
  <v-app>
    <!--<fullscreen ref="fullscreen" @change="fullscreenChange">-->
    <div v-if="isLogin">
      <core-toolbar :logout="logout" :toggle="toggle" :fullscreen="fullscreen" />
      <core-drawer />
      <core-view />
    </div>
    <div v-else>
      <Login />
    </div>
    <Loader v-if="loading" :loading="loading" />
    <!--</fullscreen>-->
  </v-app>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import Loader from "./components/helper/Loader";
import Login from "./views/Login";

export default {
  data: () => ({
    loading: true,
    loadedData: false,
    audio: null,
    isSocket: true,
    fullscreen: false
  }),
  components: { Login, Loader },
  methods: {
    ...mapMutations([
      "SET_MESSAGES_CHAT",
      "SET_BADGE",
      "SET_BRANDS",
      "SET_CLASSES",
      "SET_CATEGORIES",
      "SET_RESOURCES",
      "SET_ISLOGIN",
      "SET_FEATURES",
      "SET_VALUES"
    ]),
    initSocketChat() {
      if (this.isSocket === true) {
        this.sockets.subscribe("avtech_database_chat-admin-HDE92EWR", data => {
          this.$toast.info({
            title: "Customer Service",
            message: "Новое сообщение"
          });
          this.SET_MESSAGES_CHAT(data);
          this.initBadges();
          this.notify("Новое сообщение");
          this.audio.play();
        });
      
      
      this.sockets.subscribe(
          "avtech_database_admin_distributions_order-FKDSODFDSK8328JDSDKNLSADJKADASDAS22DDRE",
          data => {
            this.$toast.info({
              title: "Distribution",
              message: "У вас новый заказ"
            });
            this.initBadges();
            this.notify("Новый заказа по дистрибьюции");
            this.audio.play();
          }
        );

        
      this.sockets.subscribe(
          "avtech_database_admin_withdraw-FKDSODFDSK8328JDSDKNLSADJKADASDAS22DDRE",
          data => {
            this.$toast.info({
              title: "Customer Service App",
              message: "Новый запрос на вывод средств"
            });
            this.initBadges();
            this.notify("Новый запрос на вывод средств");
            this.audio.play();
          }
        );
        
      this.sockets.subscribe(
          "avtech_database_admin_export-FKDSODFDSK8328JDSDKNLSADJKADASDAS22DDRE",
          data => {

            // this.$toast.info({
            //   title: "EXCEL EXPORT FILE",
            //   message: "Файл EXPORT готов"
            // });

              const url = window.URL.createObjectURL(new Blob([data.fileName]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "activations.xlsx"); 
              document.body.appendChild(link);
              link.click();
            console.log(data);
            // this.audio.play();
          }
        );

        this.sockets.subscribe(
          "avtech_database_rating-882220D7A4F4898CCED7E9E8B85EB5DD1D0C45F3CE8EBACB10D4A0F96D5AA639",
          data => {
            if (data) {
              this.$toast.info({
                title: "Customer Service",
                message: "У вас новые уведомления"
              });
              this.initBadges();
              this.notify("У вас новые уведомление");
              this.audio.play();
            }
          }
        );
        this.isSocket = false;
      }
    },
    notify(message) {
      this.$notification.show(
        "Customer Service",
        {
          body: message,
          icon: "/img/logo.png"
        },
        {}
      );
    },
    initBadges() {
      axios
        .get("admin/badges")
        .then(async response => {
          await this.SET_BADGE(response.data);
        })
        .catch(error => {})
        .finally(() => {});
    },
    initBrands() {
      axios
        .get("admin/products/brands")
        .then(async response => {
          await this.SET_BRANDS(response.data.brands);
          this.loadedData = true;
        })
        .catch(error => {})
        .finally(() => {
          this.initFeatures();
        });
    },
    initFeatures() {
      axios
        .get("admin/products/features")
        .then(async response => {
          await this.SET_FEATURES(response.data.features);
          this.loadedData = true;
        })
        .catch(error => {})
        .finally(() => {
          this.initValues();
        });
    },
    initValues() {
      axios
        .get("admin/products/values")
        .then(async response => {
          await this.SET_VALUES(response.data.values);
          this.loadedData = true;
        })
        .catch(error => {})
        .finally(() => {
          this.initCategories();
        });
    },
    initCategories() {
      axios
        .get("admin/products/categories")
        .then(async response => {
          await this.SET_CATEGORIES(response.data.categories);
          this.loadedData = true;
        })
        .catch(() => {})
        .finally(() => {
          this.initClasses();
        });
    },
    initClasses() {
      axios
        .get("admin/products/classes")
        .then(async response => {
          await this.SET_CLASSES(response.data.classes);
          this.loadedData = true;
        })
        .catch(() => {})
        .finally(() => {
          this.initResources();
        });
    },
    initResources() {
      axios
        .get("admin/products/resources")
        .then(async response => {
          this.SET_ISLOGIN(true);
          await this.SET_RESOURCES(response.data.resources);
          this.initSocketChat();
          this.initBadges();
          this.loadedData = true;
        })
        .catch(() => {})
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 600);
        });

      // this.$dialog
      //     .confirm('Сделать полноэкранный режим?', {
      //         okText: 'Да',
      //         cancelText: 'Нет'
      //     })
      //     .then(() => {
      //         this.toggle();
      //     })
      //     .catch(() => {
      //
      //     });
    },
    logout() {
      this.$dialog
        .confirm("Вы точно хотите выйти?", {
          okText: "Выйти",
          cancelText: "Отмена"
        })
        .then(() => {
          this.SET_ISLOGIN(false);
          localStorage.clear();
          window.axios.defaults.headers.common["Authorization"] = "";
        })
        .catch(() => {});
    },

    fullscreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    toggle() {
      this.$refs["fullscreen"].toggle(); // recommended
    }
  },
  created() {
    this.$store.dispatch("languageAction");

    this.initBrands();
  },
  mounted() {
    this.audio = new Audio("/notify.mp3");
  },
  computed: {
    ...mapState(["isLogin", "language"])
  },
  watch: {
    isLogin(val) {
      if (val && this.loadedData === false) {
        this.initBrands();
      }
    },
    language(val) {
      if (val && val === localStorage.getItem("language")) {
        this.loading = true;
        this.initBrands();
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/index.scss";

/* Remove in 1.2 */
.v-datatable thead th.column.sortable i {
  vertical-align: unset;
}

.theme--light.v-table {
  color: #666 !important;
}

.fullscreen {
  z-index: -5;
  background: #ebebeb !important;
}
</style>
